<template lang="pug">
  v-layout.box-mis-seguros-desktop-formatter(column)
    v-flex
      v-layout.box-data(column)
        v-flex.box-element
          IconTextIconText(
            :textMisDatos1="'N° de póliza'"
            :iconMisDatos1="iconPoliza"
            :textMisDatos2="numeroPoliza")
        v-flex.box-element
          IconTextIconText(
            :textMisDatos1="'Vigencia'"
            :iconMisDatos1="iconCalendar"
            :textMisDatos2="inicioFinVigencia")
        v-flex.box-element
          IconTextIconText(
            textTransform="lowercase"
            :textMisDatos1="'Periodo de pago'"
            :iconMisDatos1="iconCalendar"
            :textMisDatos2="periodoDePago")
        v-flex.box-element(v-if="plan == 'VIDA FREE PLUS' || plan == 'VIDA FREE TOTAL' || (oriProducto || '').includes('VIDA_CASH_PLUS')")
          IconTextIconText(
            textTransform="lowercase"
            :textMisDatos1="'Periodo de cobertura'"
            :iconMisDatos1="iconCalendar"
            :textMisDatos2="periodoDeCobertura || '## años'")
        //-- MONTO DE DEVOLUCION Y MONTO ASEGURADO no están en el BUC DATA LOADER
        //-- porcentajeDevolucion, periodoPago, pagoTotal, montoDevolucion NO ESTA EN EL BUC DATA LOADER
        v-flex.box-element(v-if="producto == 'PLANGARANTIZADO'")
          IconTextIconText(
            :textMisDatos1="producto !== 'PLANGARANTIZADO' ? 'Monto de devolución' : 'Monto asegurado'"
            :iconMisDatos1="iconMontoAsegurado"
            :iconMisDatos2="iconInfoIncognito"
            :textMisDatos2="tipoMoneda + '' + montoAsegurado"
            :textIconMisDatos2="producto == 'VIDAFREE' ? 'La suma de tus aportes más rentabilidad.' : ( producto.includes('VIDACASH') ? 'Dinero que voy a recibir al término de mi periodo de pago.' : 'El monto indicado es la suma asegurada por fallecimiento.')")
        v-flex.box-element
          IconTextIconText(
            :textMisDatos1="'Cuota'"
            :iconMisDatos1="iconMontoCuota"
            :textMisDatos2="cuota")
        v-flex.box-element
          IconTextIconText(
            :textMisDatos1="'Frecuencia de pago'"
            :iconMisDatos1="iconFrecuenciaPago"
            :textMisDatos2="frecuenciaDePago")
        v-flex.box-element.box-element(v-if="!(oriProducto || '').includes('VIDA_CASH_PLUS')")
          IconTextIconText(
            :textMisDatos1="'Pagado hasta'"
            :iconMisDatos1="iconPagoHasta"
            :textMisDatos2="pagoHasta")
    v-flex
      v-layout(v-if="hasDocument" align-center column style="margin-top:1.5em; margin-bottom:0.8em")
        v-flex
          v-btn(
            @click="descargarPoliza"
            color="#EA0D90"
            style="width: 16em;height: 3.3em;")
            span(style="text-transform: none; color: #ffffff; font-size: 16px;") Descargar mi póliza
      v-layout(v-else style="margin-bottom: 1.5em;margin-top: 1em;width: 21em;margin-left: auto;margin-right: auto;")
        v-flex( xs1 mr-2)
          img(:src="iconAlerta")
        v-flex(style="line-height:normal;text-align: justify;")
          span(style="color: #919191;font-size:13px;") Muy pronto tu póliza estará disponible, pero si deseas solicitarla, por favor comunícate &nbsp;
            a(:href="links.WhatsApp" target="_blank" style="cursor:pointer;font-family: 'Omnes Medium';") aquí

</template>

<script>
import * as d3 from 'd3'
import { mapActions } from 'vuex'
import Links from '../../interfaces/links'
import IconTextIconText from '../generic/IconTextIconText.vue'

export default {
  props: [
    'numeroPoliza',
    'inicioFinVigencia',
    'periodoDePago',
    'periodoDeCobertura',
    'montoAsegurado',
    'cuota',
    'frecuenciaDePago',
    'pagoHasta',
    'tipoMoneda',
    'taggeo',
    'producto',
    'plan',
    'oriProducto',
    'hasDocument'
  ],
  data() {
    return {
      links: Links,
      iconPoliza: require('./../../assets/icons-mis-seguros/icon-numero-poliza.svg'),
      iconCalendar: require('./../../assets/icons-mis-seguros/icon-vigencia-seguro.svg'),
      iconPeriodoGarantizado: require('./../../assets/icons-mis-seguros/icon-vigencia-seguro.svg'),
      iconMontoAsegurado: require('./../../assets/icons-mis-seguros/icon-monto-asegurado.svg'),
      iconMontoCuota: require('./../../assets/icons-mis-seguros/icon-cuota.svg'),
      iconFrecuenciaPago: require('./../../assets/icons-mis-seguros/icon-frecuencia-pago.svg'),
      iconPagoHasta: require('./../../assets/icons-mis-seguros/icon-pago-hasta.svg'),
      iconAlerta: require('./../../assets/iconsv5/icon-alert.svg'),
      iconInfoIncognito: require('./../../assets/icons-mis-seguros/icon-info-incognito.svg')
    }
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    descargarPoliza() {
      this.$emit('datosMisSegurosMethod')
    }
  },
  components: {
    IconTextIconText
  },
  mounted() {
    let self = this

    const metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', { seccion: 'Mis seguros - Plan - Datos de mi seguro', metadata })

    d3.select('.box-mis-seguros-desktop-formatter')
      .style('opacity', '0')
      .transition().duration(300)
      .style('opacity', '1')

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'desktop',
        'seccion': 'datos de mis seguros'
      }
    })
  }
}
</script>

<style>
.box-mis-seguros-desktop-formatter {
  margin: 0.8em 1em;
}

.box-mis-seguros-desktop-formatter .box-data {
  padding: 0em 1.3em !important;
}

.box-mis-seguros-desktop-formatter .box-data .box-element {
  border-bottom: 1px solid #C4C4C4;
  padding-left: 1em;
  padding-bottom: 0.7em;
  padding-top: 0.7em;
}

.box-mis-seguros-desktop-formatter .box-data .box-element:last-child {
  border-bottom: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/DatosMisSegurosDesktop.vue